/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetFileType {
    Sonstiges = 'Sonstiges',
    Rechnung = 'Rechnung',
    Kaufvertrag = 'Kaufvertrag',
    Fuehrerschein = 'Fuehrerschein',
    Zulassungsschein = 'Zulassungsschein',
    Vollmachtsvereinbarung = 'Vollmachtsvereinbarung',
    Maklervertrag = 'Maklervertrag',
    Beratungsprotokoll = 'Beratungsprotokoll',
    Firmenbuchauszug = 'Firmenbuchauszug',
    Bilanz = 'Bilanz',
    Offert = 'Offert',
    Vertragsbedingungen = 'Vertragsbedingungen',
    Avb = 'Avb',
    Ipid = 'Ipid',
    OriginalPolizze = 'OriginalPolizze',
    Polizze = 'Polizze',
    Polizzierungsauftrag = 'Polizzierungsauftrag',
    Antrag = 'Antrag',
    AntragVorschau = 'AntragVorschau',
    PramienSchadenaufstellung = 'PramienSchadenaufstellung',
    Stornopolizze = 'Stornopolizze',
    Kuendigung = 'Kuendigung',
    Versicherungsbestaetigung = 'Versicherungsbestaetigung',
    BestaetigungKennzeichenHinterlegung = 'BestaetigungKennzeichenHinterlegung',
    BestaetigungVertragsruhenmeldung = 'BestaetigungVertragsruhenmeldung',
    BestaetigungWiederinkraftsetzung = 'BestaetigungWiederinkraftsetzung',
    Hochwasserkarte = 'Hochwasserkarte',
    Ausschreibung = 'Ausschreibung',
    AusschreibungsVorschau = 'AusschreibungsVorschau',
    AusschreibungsVergleich = 'AusschreibungsVergleich',
    Schadensbild = 'Schadensbild',
    SchadensbildFuehrerschein = 'SchadensbildFuehrerschein',
    SchadensbildFuehrerscheinUnfallgegner = 'SchadensbildFuehrerscheinUnfallgegner',
    Schadensdokument = 'Schadensdokument',
    NewsFeedStellaMainImage = 'NewsFeedStellaMainImage',
    NewsFeedImage = 'NewsFeedImage',
    NewsFeedDocument = 'NewsFeedDocument',
    NewsFeedVideo = 'NewsFeedVideo',
    ChatBild = 'ChatBild',
    Chatdokument = 'Chatdokument',
    Profilbild = 'Profilbild',
    Logo = 'Logo'
  }

    export const BrokernetFileTypeTranslocoMap: Record<BrokernetFileType, string> = {
    [BrokernetFileType.Sonstiges]: 'brokernetFileType.sonstiges',
    [BrokernetFileType.Rechnung]: 'brokernetFileType.rechnung',
    [BrokernetFileType.Kaufvertrag]: 'brokernetFileType.kaufvertrag',
    [BrokernetFileType.Fuehrerschein]: 'brokernetFileType.fuehrerschein',
    [BrokernetFileType.Zulassungsschein]: 'brokernetFileType.zulassungsschein',
    [BrokernetFileType.Vollmachtsvereinbarung]: 'brokernetFileType.vollmachtsvereinbarung',
    [BrokernetFileType.Maklervertrag]: 'brokernetFileType.maklervertrag',
    [BrokernetFileType.Beratungsprotokoll]: 'brokernetFileType.beratungsprotokoll',
    [BrokernetFileType.Firmenbuchauszug]: 'brokernetFileType.firmenbuchauszug',
    [BrokernetFileType.Bilanz]: 'brokernetFileType.bilanz',
    [BrokernetFileType.Offert]: 'brokernetFileType.offert',
    [BrokernetFileType.Vertragsbedingungen]: 'brokernetFileType.vertragsbedingungen',
    [BrokernetFileType.Avb]: 'brokernetFileType.avb',
    [BrokernetFileType.Ipid]: 'brokernetFileType.ipid',
    [BrokernetFileType.OriginalPolizze]: 'brokernetFileType.originalPolizze',
    [BrokernetFileType.Polizze]: 'brokernetFileType.polizze',
    [BrokernetFileType.Polizzierungsauftrag]: 'brokernetFileType.polizzierungsauftrag',
    [BrokernetFileType.Antrag]: 'brokernetFileType.antrag',
    [BrokernetFileType.AntragVorschau]: 'brokernetFileType.antragVorschau',
    [BrokernetFileType.PramienSchadenaufstellung]: 'brokernetFileType.pramienSchadenaufstellung',
    [BrokernetFileType.Stornopolizze]: 'brokernetFileType.stornopolizze',
    [BrokernetFileType.Kuendigung]: 'brokernetFileType.kuendigung',
    [BrokernetFileType.Versicherungsbestaetigung]: 'brokernetFileType.versicherungsbestaetigung',
    [BrokernetFileType.BestaetigungKennzeichenHinterlegung]: 'brokernetFileType.bestaetigungKennzeichenHinterlegung',
    [BrokernetFileType.BestaetigungVertragsruhenmeldung]: 'brokernetFileType.bestaetigungVertragsruhenmeldung',
    [BrokernetFileType.BestaetigungWiederinkraftsetzung]: 'brokernetFileType.bestaetigungWiederinkraftsetzung',
    [BrokernetFileType.Hochwasserkarte]: 'brokernetFileType.hochwasserkarte',
    [BrokernetFileType.Ausschreibung]: 'brokernetFileType.ausschreibung',
    [BrokernetFileType.AusschreibungsVorschau]: 'brokernetFileType.ausschreibungsVorschau',
    [BrokernetFileType.AusschreibungsVergleich]: 'brokernetFileType.ausschreibungsVergleich',
    [BrokernetFileType.Schadensbild]: 'brokernetFileType.schadensbild',
    [BrokernetFileType.SchadensbildFuehrerschein]: 'brokernetFileType.schadensbildFuehrerschein',
    [BrokernetFileType.SchadensbildFuehrerscheinUnfallgegner]: 'brokernetFileType.schadensbildFuehrerscheinUnfallgegner',
    [BrokernetFileType.Schadensdokument]: 'brokernetFileType.schadensdokument',
    [BrokernetFileType.NewsFeedStellaMainImage]: 'brokernetFileType.newsFeedStellaMainImage',
    [BrokernetFileType.NewsFeedImage]: 'brokernetFileType.newsFeedImage',
    [BrokernetFileType.NewsFeedDocument]: 'brokernetFileType.newsFeedDocument',
    [BrokernetFileType.NewsFeedVideo]: 'brokernetFileType.newsFeedVideo',
    [BrokernetFileType.ChatBild]: 'brokernetFileType.chatBild',
    [BrokernetFileType.Chatdokument]: 'brokernetFileType.chatdokument',
    [BrokernetFileType.Profilbild]: 'brokernetFileType.profilbild',
    [BrokernetFileType.Logo]: 'brokernetFileType.logo',
    };

    export const BrokernetFileTypeOptions = [
  { value: BrokernetFileType.Sonstiges, labelKey: 'brokernetFileType.sonstiges' },
  { value: BrokernetFileType.Rechnung, labelKey: 'brokernetFileType.rechnung' },
  { value: BrokernetFileType.Kaufvertrag, labelKey: 'brokernetFileType.kaufvertrag' },
  { value: BrokernetFileType.Fuehrerschein, labelKey: 'brokernetFileType.fuehrerschein' },
  { value: BrokernetFileType.Zulassungsschein, labelKey: 'brokernetFileType.zulassungsschein' },
  { value: BrokernetFileType.Vollmachtsvereinbarung, labelKey: 'brokernetFileType.vollmachtsvereinbarung' },
  { value: BrokernetFileType.Maklervertrag, labelKey: 'brokernetFileType.maklervertrag' },
  { value: BrokernetFileType.Beratungsprotokoll, labelKey: 'brokernetFileType.beratungsprotokoll' },
  { value: BrokernetFileType.Firmenbuchauszug, labelKey: 'brokernetFileType.firmenbuchauszug' },
  { value: BrokernetFileType.Bilanz, labelKey: 'brokernetFileType.bilanz' },
  { value: BrokernetFileType.Offert, labelKey: 'brokernetFileType.offert' },
  { value: BrokernetFileType.Vertragsbedingungen, labelKey: 'brokernetFileType.vertragsbedingungen' },
  { value: BrokernetFileType.Avb, labelKey: 'brokernetFileType.avb' },
  { value: BrokernetFileType.Ipid, labelKey: 'brokernetFileType.ipid' },
  { value: BrokernetFileType.OriginalPolizze, labelKey: 'brokernetFileType.originalPolizze' },
  { value: BrokernetFileType.Polizze, labelKey: 'brokernetFileType.polizze' },
  { value: BrokernetFileType.Polizzierungsauftrag, labelKey: 'brokernetFileType.polizzierungsauftrag' },
  { value: BrokernetFileType.Antrag, labelKey: 'brokernetFileType.antrag' },
  { value: BrokernetFileType.AntragVorschau, labelKey: 'brokernetFileType.antragVorschau' },
  { value: BrokernetFileType.PramienSchadenaufstellung, labelKey: 'brokernetFileType.pramienSchadenaufstellung' },
  { value: BrokernetFileType.Stornopolizze, labelKey: 'brokernetFileType.stornopolizze' },
  { value: BrokernetFileType.Kuendigung, labelKey: 'brokernetFileType.kuendigung' },
  { value: BrokernetFileType.Versicherungsbestaetigung, labelKey: 'brokernetFileType.versicherungsbestaetigung' },
  { value: BrokernetFileType.BestaetigungKennzeichenHinterlegung, labelKey: 'brokernetFileType.bestaetigungKennzeichenHinterlegung' },
  { value: BrokernetFileType.BestaetigungVertragsruhenmeldung, labelKey: 'brokernetFileType.bestaetigungVertragsruhenmeldung' },
  { value: BrokernetFileType.BestaetigungWiederinkraftsetzung, labelKey: 'brokernetFileType.bestaetigungWiederinkraftsetzung' },
  { value: BrokernetFileType.Hochwasserkarte, labelKey: 'brokernetFileType.hochwasserkarte' },
  { value: BrokernetFileType.Ausschreibung, labelKey: 'brokernetFileType.ausschreibung' },
  { value: BrokernetFileType.AusschreibungsVorschau, labelKey: 'brokernetFileType.ausschreibungsVorschau' },
  { value: BrokernetFileType.AusschreibungsVergleich, labelKey: 'brokernetFileType.ausschreibungsVergleich' },
  { value: BrokernetFileType.Schadensbild, labelKey: 'brokernetFileType.schadensbild' },
  { value: BrokernetFileType.SchadensbildFuehrerschein, labelKey: 'brokernetFileType.schadensbildFuehrerschein' },
  { value: BrokernetFileType.SchadensbildFuehrerscheinUnfallgegner, labelKey: 'brokernetFileType.schadensbildFuehrerscheinUnfallgegner' },
  { value: BrokernetFileType.Schadensdokument, labelKey: 'brokernetFileType.schadensdokument' },
  { value: BrokernetFileType.NewsFeedStellaMainImage, labelKey: 'brokernetFileType.newsFeedStellaMainImage' },
  { value: BrokernetFileType.NewsFeedImage, labelKey: 'brokernetFileType.newsFeedImage' },
  { value: BrokernetFileType.NewsFeedDocument, labelKey: 'brokernetFileType.newsFeedDocument' },
  { value: BrokernetFileType.NewsFeedVideo, labelKey: 'brokernetFileType.newsFeedVideo' },
  { value: BrokernetFileType.ChatBild, labelKey: 'brokernetFileType.chatBild' },
  { value: BrokernetFileType.Chatdokument, labelKey: 'brokernetFileType.chatdokument' },
  { value: BrokernetFileType.Profilbild, labelKey: 'brokernetFileType.profilbild' },
  { value: BrokernetFileType.Logo, labelKey: 'brokernetFileType.logo' },
    ];

